module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-12.8623299e.png";